module.exports = __webpack_public_path__ + "static/media/3.fccb13c5.svg";